module.exports = __webpack_public_path__ + "img/logo.b92c1638.png";